import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findTemplateQuestions = createAsyncThunk(
  "templateDetail/findQuestions",
  async (id: string, { rejectWithValue, getState }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}formquestion`, {
        params: {
          where: {
            form: id,
          },
        },
      });

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
